import { getFullName } from '@domain/member';
import { MemberLight, MemberSummary } from '@wwf/sdk';
import { Stack, Typography } from '@mui/material';
import { Link, useRecordContext } from 'react-admin';
import { MemberAvatar } from './MemberAvatar';
import { getLinkToMember } from '../getLinkToMember';

export const MemberLightCard = (props: {
    record?: MemberLight | MemberSummary;
    noLink?: boolean;
}) => {
    const record = useRecordContext<MemberLight | MemberSummary>(props);
    if (!record) return null;

    const content = (
        <Stack
            direction="row"
            alignItems="center"
            gap={0.5}
            sx={{ minWidth: 0, width: '100%' }}
        >
            <MemberAvatar variant="sm" record={record} />
            <Stack sx={{ minWidth: 0, flex: 1, overflow: 'hidden' }}>
                <Typography variant="body2" noWrap>
                    {getFullName(record)}
                </Typography>
                {record.antennas && record.antennas.length > 0 && (
                    <Typography variant="caption" noWrap>
                        {record.antennas && ' at '}
                        {record.antennas
                            ?.map(antenna => antenna.name)
                            .join(', ')}
                    </Typography>
                )}
            </Stack>
        </Stack>
    );

    return props.noLink ? (
        content
    ) : (
        <Link to={getLinkToMember(record.id)}>{content}</Link>
    );
};
